module.exports = __webpack_public_path__ + "src/assets/img/quto.ed78368f.jpg";